export default "__VITE_ASSET__cLYpZMS___"